<template>
  <div class="personal-info">
    <div class="authentication" v-if="!isLogin">
      <i class="iconfont icon-tishi"></i>
      <div class="call">尊敬的客户</div>
      <div class="notice">
        您还未登录，
        <span @click="$router.push({ name: 'login' })">立即登录</span>
        <span @click="$router.push({ name: 'home' })">返回首页</span>
      </div>
    </div>
    <div v-else>
      <div class="title">基本信息
        <!-- <span @click="$router.go(-1)">
          <icon-svg name="back"></icon-svg>
        </span> -->
      </div>
      <el-form label-position="left"
              :model="personData"
              ref="personData"
              :rules="rules"
              label-width="120px"
              class="personal-center">
        <el-form-item label="头像：">
          <div class="head-portrait-box">
            <upfile v-model="personData.avatarUrl"
                    :cutOption="{width: 240, height: 240}"
                    @change="changeUrl"></upfile>
            <p style="width: 80px;font-size: 12px; margin: 0;text-align: center;line-height: 24px;color: #0BA5FF">点击上传</p>
            <p style="width: 80px;font-size: 12px; margin: 0;text-align: center;line-height: 20px;">像素(240*240)</p>
          </div>
        </el-form-item>

        <el-form-item label="姓名：">
          <div style="display: flex">
            <el-input size="small"
                      style="width: 180px;"
                      v-if="activeRealName"
                      v-model="realName"></el-input>
            <div v-else>{{personData.realName}}</div>
            <div class="personal-edit">
              <i class="iconfont" 
                 :class="[activeRealName ? 'icon-queding' : 'icon-editor']"
                 @click="editRealName"></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="注册时间：">
          <span>{{personData.createTime}}</span>
        </el-form-item>
        <el-form-item label="手机号：">
          <span style="padding-right: 20px">{{personData.loginAccount ? personData.loginAccount.mobile : ''}}</span>
          <el-button size="mini"
                    type="text"
                    @click="modMobile">修改密码</el-button>
        </el-form-item>
        <el-form-item label="邮箱："
                      prop="email">
          <div style="display: flex">
            <el-input size="small"
                      style="width: 180px;"
                      v-if="activeEmail"
                      v-model="personData.email"></el-input>
            <span v-else>{{personData.loginAccount ? personData.loginAccount.email : ''}}</span>
            <div class="personal-edit">
              <i class="iconfont" 
                 :class="[activeEmail ? 'icon-queding' : 'icon-editor']"
                  @click="editEmail"></i>
            </div>
          </div>
        </el-form-item>
        <!-- <div style="padding: 0 0 20px 100px">
          <el-popover placement="top"
                      width="300"
                      trigger="click"
                      style="padding: 3px 0">
            <div>
              <div id="wx_qrcode"></div>
            </div>
            <el-button slot="reference"
                      icon="el-icon-plus"
                      type="text">绑定微信</el-button>
          </el-popover>
        </div> -->

        <div class="title" style="margin-top: 20px">会员信息</div>
        <div v-if="!memberData.id">
          <div class="no-data">您还不是会员</div>
          <div style="text-align: center">
            <el-button type="primary"
                      @click="$router.push('/menberIntroduce')">会员服务</el-button>
          </div>
        </div>
        <div v-else>
          <el-form-item label="会员等级：">
            <span>{{memberData.levelCode === 'BASIC' ? '基础会员' : memberData.levelCode === 'FREE' ? '免费用户' : ''}}</span>
          </el-form-item>
          <el-form-item label="会员生效时间：">
            <span>{{memberData.startTime + '~' + memberData.endTime}}</span>
          </el-form-item>
        </div>

        <div class="title" style="margin-top: 20px">订单信息</div>
        <listCommon :table-list="orderArray"
                    :columnList="columnOrder"
                    :show-selection="false"
                    :isExport="false"
                    :showEdit="true"
                    :show-order="true"
                    :showPopover="false">

          <template slot="operator"
                    slot-scope="prop">
            <el-button type="text"
                        size="mini"
                        class="delete-list"
                        @click="deleteOrder(prop.row.id)">删除</el-button>
          </template>
        </listCommon>


        <div class="title" style="margin-top: 20px">开票信息</div>
        <listCommon :fn="info"
                    :table-list="tariffsArray"
                    :columnList="columnArray"
                    :show-selection="false"
                    :isExport="false"
                    :showEdit="true"
                    :show-order="true">
          <template slot="tabButton">
            <el-button type="primary"
                        size="mini"
                        @click="info()">新增</el-button>
          </template>

          <template slot="invoiceType" slot-scope="prop">
            <span>{{getSelectDesc(prop.row.invoiceType, enumeration.invoiceTypes, 'value', 'label')}}</span>
          </template>

          <template slot="operator"
                    slot-scope="prop">
            <el-button type="text"
                        size="mini"
                        class="delete-list"
                        @click="deleteItem(prop.row.id)">删除</el-button>
          </template>
        </listCommon>
      </el-form>
    </div>

    <el-dialog title="修改密码"
               append-to-body
               :visible.sync="dialogVisible"
               width="600px"
               @close="cancel">
      <el-form :model="dataForm"
               :rules="rules2"
               size="small"
               ref="dataForm"
               label-width="100px"
               class="demo-ruleForm">
        <!-- 输入原密码修改 -->
        <div v-if="editPasswordType === 1">
          <el-form-item label="原密码："
                        prop="password">
            <el-input type="password"
                      style="width: 300px"
                      v-model="dataForm.password"></el-input>
            <span @click="editPasswordType = 2"
                  style="color: #0ba5ff;cursor: pointer">忘记原密码？</span>
          </el-form-item>
          <el-form-item label="新密码："
                        prop="newPassword">
            <el-input type="password"
                      style="width: 300px"
                      v-model="dataForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码："
                        prop="confirmPassword">
            <el-input type="password"
                      style="width: 300px"
                      v-model="dataForm.confirmPassword"></el-input>
          </el-form-item>
        </div>
        <!-- 手机验证 -->
        <div v-if="editPasswordType === 2">
          <el-form-item prop="phone"
                        label="手机号：">
            <el-input v-model="dataForm.phone"
                      class="account"
                      style="width: 300px"
                      placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="captcha"
                        label="短信验证码：">
            <div class="captcha-box">
              <el-input v-model="dataForm.captcha"
                        class="code"
                        placeholder="短信验证码">
              </el-input>
              <el-button size="mini"
                         @click="getCode"
                         :disabled="codeDisabled"
                         class="slotButton">
                {{codeDisabled?'重新发送'+count+'S':'发送验证码'}}
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="新密码："
                        prop="newPassword">
            <el-input type="password"
                      style="width: 300px"
                      v-model="dataForm.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码："
                        prop="confirmPassword">
            <el-input type="password"
                      style="width: 300px"
                      v-model="dataForm.confirmPassword"></el-input>
          </el-form-item>
          <el-form-item>
            <span style="color: #0ba5ff;cursor: pointer"
                  @click="editPasswordType = 1">输入原密码修改</span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="confirmEditPhone"
                   :loading="saveState">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增开票信息"
               append-to-body
               :visible.sync="invoiceVisible"
               width="800px"
               @close="invoiceCancel">
      <div style="width: 400px;margin: auto">
        <el-form :model="formData"
                 :rules="invoiceRules"
                 ref="formData"
                 size="small"
                 label-width="90px"
                 class="demo-ruleForm">
          <el-form-item label="发票抬头："
                        prop="companyName">
            <el-input v-model="formData.companyName"></el-input>
          </el-form-item>
          <el-form-item label="税号："
                        prop="taxNumber">
            <el-input v-model="formData.taxNumber"></el-input>
          </el-form-item>
          <el-form-item label="联系人："
                        prop="contactName">
            <el-input v-model="formData.contactName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话："
                        prop="contactPhone">
            <el-input v-model="formData.contactPhone"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="invoiceCancel">取 消</el-button>
        <el-button type="primary"
                   @click="confirmEditInvoice"
                   :loading="saveState">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import upfile from '@/components/upload/upfile2'
import listCommon from '@/components/list-common'

var defaultColumns = [
  {
    props: 'companyName',
    labels: '发票抬头',
    widths: 180
  },
  {
    props: 'taxNumber',
    labels: '税号',
    widths: 140
  },
  // {
  //   props: 'invoiceType',
  //   labels: '发票类型',
  //   widths: 80,
  //   slot: true
  // },
  {
    props: 'contactName',
    labels: '联系人',
    widths: 100
  },
  {
    props: 'contactPhone',
    labels: '联系电话',
    widths: 100
  },
]

export default {
  components: {
    upfile,
    listCommon
  },
  data () {
    let pwPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!pwPattern.test(value)) {
        callback(new Error('密码必须是包含大小写字母和数字的8到20位组合'))
      } else {
        if (this.dataForm.confirmPassword !== '') {
          this.$refs.dataForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.dataForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    let gangPhone = /^[0-9]{8}$/
    let validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value) && !gangPhone.test(value)) {
        callback(new Error('请输入手机号码'))
      } else {
        callback()
      }
    }
    return {
      memberData: {},
      orderArray: [],
      columnOrder: [
        {
          props: 'orderNo',
          labels: '订单编号',
          widths: 130,
          // slot: true
        },
        // {
        //   props: 'memberName',
        //   labels: '会员名称',
        //   widths: 120
        // },
        {
          props: 'amount',
          labels: '价格',
          widths: 60
        },
        {
          props: 'memberLevelName',
          labels: '会员等级',
          widths: 70
        },
        {
          props: 'paymentTime',
          labels: '支付时间',
          widths: 120
        },
        {
          props: 'startTime',
          labels: '开始时间',
          widths: 120,
        },
        {
          props: 'endTime',
          labels: '结束时间',
          widths: 120,
        },
        {
          props: 'statusDesc',
          labels: '订单状态',
          widths: 70,
        }
      ],
      invoiceRules: {},
      formData: {},
      invoiceVisible: false,
      tariffsArray: [], // 列表数据
      columnArray: defaultColumns, // 表头数组
      realName: '',
      activeRealName: false,
      email: '',
      activeEmail: false,
      uploadUrl: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/file/uploadFile'),
      userUrl: require('../../assets/img/layout/photo.png'),
      saveState: false,
      dialogVisible: false,
      loadState: false,
      dataForm: {
        newPassword: '',
        confirmPassword: '',
        password: ''
      },
      personData: {},
      rules: {
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['change'] }
        ],
      },
      rules2: {
        newPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { max: 12, message: '长度不能超过12位', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '短信验证码不能为空', trigger: 'blur' }
        ]
      },
      count: null,
      codeDisabled: false,
      editPasswordType: 1 // 1-原密码找回，2-手机验证码验证
    }
  },
  props: {
  },
  computed: {
    // avatarUrl: {
    //   set (val) {
    //     this.$store.commit('user/updateAvatarUrl', val)
    //   }
    // },
    isLogin: {
      get () {
        return this.$store.state.user.isLogin
      },
    },
  },
  created () {
    this.getPersonData()
    // this.getUserMember()
  },
  mounted () {
    // this.$nextTick(() => {
    //   window.scrollTo(0, document.body.scrollHeight)
    // })
  },
  methods: {
    getUserMember () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/userMember/get'),
        method: 'get',
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.memberData = res.data.result || {}
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    editRealName () {
      this.activeRealName = !this.activeRealName
      if (this.activeRealName) { // 打开编辑
        this.realName = this.personData.realName
      } else { // 确定编辑
        if (this.realName !== this.personData.realName) {
          this.$http({
            url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/user/updateUserInfo'),
            method: 'post',
            data: { id: this.personData.id, realName: this.realName }
          }).then((res) => {
            if (res.data && res.data.code === 'C0000') {
              this.$message.success('修改成功')
              this.personData.realName = this.realName
              this.ActionsRealName(this.realName)
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      }
    },
    editEmail () {
      if (!this.activeEmail) { // 打开编辑
        this.activeEmail = !this.activeEmail
        this.personData.email = this.personData.loginAccount.email
      } else { // 确定编辑
        if (this.personData.email !== this.personData.loginAccount.email) {
          this.$refs['personData'].validateField('email', emailError => {
            if (!emailError) {
              this.$http({
                url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/user/updateUserInfo'),
                method: 'post',
                data: { id: this.personData.id, email: this.personData.email }
              }).then((res) => {
                if (res.data && res.data.code === 'C0000') {
                  this.$message.success('修改成功')
                  this.activeEmail = !this.activeEmail
                  this.personData.loginAccount.email = this.personData.email
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } else {
              return false;
            }
          })
        } else {
          this.activeEmail = !this.activeEmail
        }
      }
    },
    getOrderArray () {
       this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/memberOrder/list'),
        method: 'post',
        data: {
          isPage: false,
          data: {
            memberId: this.personData.id
          }
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.orderArray = res.data.result.list || []
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    confirmEditInvoice () {
      this.$refs['formData'].validate((valid) => {
        if (!valid) {
          this.$message.error('输入内容不符合规范，请检查')
          return
        }
        this.saveState = true
        this.formData.userId = this.personData.id
        let urlStr = !this.formData.id ? '/invoice/add' : '/invoice/mod'
        this.$http({
          url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + urlStr),
          method: 'post',
          data: this.formData
        }).then((res) => {
          if (res.data && res.data.code === 'C0000') {
            this.$message.success(res.data.message)
            this.invoiceVisible = false
            this.getDataList()
          } else {
            this.$message.error(res.data.message)
          }
        }).finally(() => {
          this.saveState = false
        })
      })
    },
    getDataList () {
      if (!this.personData.id) return 
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/invoice/list'),
        method: 'post',
        data: {
          isPage: false,
          data: {
            userId: this.personData.id
          }
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.tariffsArray = res.data.result.list || []
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    deleteOrder (id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.$http({
            url: this.$http.adornUrl(window.SITE_CONFIG['basContextPath'] + '/memberOrder/del'),
            method: 'post',
            data: { ids: [id] }
          }).then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message.success('删除成功!')
              this.getOrderArray()
            } else {
              this.$message.error(data.message)
            }
          })
        })
    },
    deleteItem (id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          this.$http({
            url: this.$http.adornUrl(window.SITE_CONFIG['basContextPath'] + '/invoice/del'),
            method: 'post',
            data: { ids: [id] }
          }).then(({ data }) => {
            if (data && data.code === 'C0000') {
              this.$message.success('删除成功!')
              this.getDataList()
            } else {
              this.$message.error(data.message)
            }
          })
        })
    },
    info (row) {
      row = row || {
        isEnabled: true,
        isDefault: 0,
        invoiceType: 1 // 普通发票
      }
      this.formData = {...row}
      this.invoiceVisible = true
    },
    invoiceCancel () {
      this.invoiceVisible = false
      this.$refs['formData'].resetFields()
    },
    cancel () {
      this.editPasswordType = 1
      this.dialogVisible = false
      this.$refs['dataForm'].resetFields()
    },
    changeUrl (val) {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/user/updateUserInfo'),
        method: 'post',
        data: { id: this.personData.id, avatarUrl: val }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.$message.success('修改成功')
          // this.avatarUrl = val
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    confirmEditPhone () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          this.$message.error('输入内容不符合规范，请检查')
          return
        }
        this.saveState = true
        this.$confirm('确认修改？')
          .then(_ => {
            if (this.editPasswordType === 1) {
              this.confirmByOld()
            } else if (this.editPasswordType === 2) {
              this.confirmByMobile()
            }
          })
          .catch(_ => {
            this.$message({
              type: 'info',
              message: '已取消修改'
            })
            this.saveState = false
          })
      })
    },
    // 通过原密码修改
    confirmByOld () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/loginAccount/updatePasswordById'),
        method: 'post',
        data: {
          password: this.dataForm.password,
          newPassword: this.dataForm.newPassword,
          confirmPassword: this.dataForm.confirmPassword
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.$message.success(res.data.message)
          this.dialogVisible = false
          this.$refs['dataForm'].resetFields()
        } else {
          this.$message.error(res.data.message)
        }
      }).finally(() => {
        this.saveState = false
      })
    },
    // 通过手机及验证码修改
    confirmByMobile () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/loginAccount/updatePasswordByCaptchaAndId'),
        method: 'post',
        data: {
          newPassword: this.dataForm.newPassword,
          confirmPassword: this.dataForm.confirmPassword,
          username: this.dataForm.phone,
          captcha: this.dataForm.captcha
        }
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.$message.success(data.message)
          this.dialogVisible = false
          this.$refs['dataForm'].resetFields()
        } else {
          this.$message.error(data.message)
        }
      }).finally(() => {
        this.saveState = false
      })
    },
    modMobile () {
      this.dialogVisible = true
    },
    // 获取验证码
    getCode () {
      if (this.dataForm.phone) {
        this.codeDisabled = true
        const TIME_COUNT = 60
        this.count = TIME_COUNT
        this.time = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.codeDisabled = false
            clearInterval(this.time)
          }
        }, 1000)
        this.$http({
          url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/message/mobile/sendMobileCode?mobile=' + this.dataForm.phone),
          method: 'get'
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success('发送成功')
          } else {
            this.$message.error(data.message)
          }
        }).finally(() => {
        })
      } else {
        this.$message.error('请先输入手机号')
      }
    },
    getPersonData () {
      this.loadState = true
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.contextPath + '/p/user/getByUserCenter'),
        method: 'get'
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          this.personData = res.data.result
          this.personData.roles = ''
          if (res.data.result.avatarUrl) {
            this.userUrl = res.data.result.avatarUrl
          }

          // let uri = encodeURIComponent('http://www.dachuangtech.com/dev/wechat/callback?redirectURI=http%3A%2F%2Fwww.dachuangtech.com%2Fdev%2Fwechat%2FbindInfo%3FloginAccountId%3D' + this.personData.accountId)
          // window.WxLogin({
          //   id: 'wx_qrcode',
          //   appid: 'wx7d4520f8b3837c1f',
          //   redirect_uri: uri,
          //   response_type: 'code',
          //   scope: 'snsapi_login',
          //   state: 'login'
          // })
          this.getDataList()
          this.getOrderArray()
        } else {
          this.$message.error(res.data.message)
        }
      }).finally(() => {
        this.loadState = false
      })
    },
    ...mapActions('user', ['ActionsRealName'])
  }
}
</script>

<style lang="scss" scoped>
.captcha-box {
  width: 300px;
  display: flex;
}
.personal-edit {
  padding-left: 10px;
  font-size: 16px;
  color: #0ba5ff;
  cursor: pointer;
  font-weight: bold;
  vertical-align: -0.2em;
}
.personal-info {
  width: 100%;
  max-width: 1000px;
  margin: auto;
  padding: 30px;
  background: #fff;
  .title {
    color: #0078ff;
    font-size: 16px;
    font-weight: bold;
    border-left: 2px solid #0078ff;
    padding-left: 20px;
    margin-bottom: 20px;
    span {
      float: right;
      color: #0078ff;
      font-size: 14px;
      cursor: pointer;
      font-weight: normal;
      .icon-svg {
        width: 30px;
        height: 30px;
        margin-top: -6px;
      }
    }
    .span-btn {
      width: 70px;
      height: 26px;
      font-size: 12px;
      line-height: 26px;
      text-align: center;
      border-radius: 4px;
      background: #e1f1ff;
      cursor: pointer;
      color: #31478f;
    }
    .span-btn:hover {
      background: #0078ff;
      color: #fff;
    }
    span:hover {
      color: #0078ff;
    }
  }
  .data-info {
    .data-title {
      font-size: 20px;
      text-align: center;
      border-bottom: 1px dotted #cbdbef;
      padding-bottom: 14px;
      color: #5e6277;
    }
    .data-date {
      float: right;
      margin-top: -30px;
      color: #8a94a8;
    }
    .image {
      padding: 30px 60px;
      img {
        max-width: 100%;
      }
    }
    .info {
      font-size: 14px;
      color: #5e6277;
      line-height: 30px;
    }
  }
}
</style>

<style lang="scss">
.personal-center {
  .el-form-item {
    margin-bottom: 0;
    font-size: 14px;
  }
}
.head-portrait-box {
  padding-top: 10px;
}
.other-box {
  height: 100%;
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/personal.vue